// WS 2211251. The Customers-list "Financed" toggle (behind CONTACT_FINANCING). Kept out of the
// filters the Filters modal edits, which has no definition for it, and added only to what the list
// and the CSV export send. The backend matches it in config/filter/financed.js.
export const FINANCED_FILTER = { fieldName: 'financing', operator: 'financed', value: '', filterType: 'financed' }

// `apiFilters` is what the list already sends: an array, or "" when there are none.
export const withFinancedFilter = (apiFilters, financed) => {
  if (!financed) return apiFilters
  return [...(Array.isArray(apiFilters) ? apiFilters : []), FINANCED_FILTER]
}

// WS 2311820. With CONTACT_FINANCING_PENDING the toggle is All / Pending / Paid, kept in the same
// `financed` URL value: '1' still means Paid, so saved links keep working.
const FINANCING_OPERATORS = { 1: 'financed', pending: 'financingPending' }

export const financingFilterFor = (value) => {
  const operator = FINANCING_OPERATORS[value]
  return operator ? { ...FINANCED_FILTER, operator } : null
}

export const withFinancingFilter = (apiFilters, value) => {
  const filter = financingFilterFor(value)
  if (!filter) return apiFilters
  return [...(Array.isArray(apiFilters) ? apiFilters : []), filter]
}
